/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Dialog" |
*
* @param {Drastic_Tech_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_close_label = /** @type {((inputs?: Drastic_Tech_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi finestra di dialogo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть диалоговое окно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar diálogo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダイアログを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar caixa de diálogo")
	return /** @type {LocalizedString} */ ("Close Dialog")
});